import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { PlanesProvider, ProyectQr, PdfCarpetaProyectQr } from '../../providers/planes';
import { AuthProvider } from '../../providers/auth';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import { Subject } from 'rxjs';
import { debounceTime } from 'rxjs/operators';
import { NgbModal, ModalDismissReasons, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';

@Component({
    selector: 'app-redirect-pqr',
    templateUrl: './redirect-pqr.component.html',
    styleUrls: ['./redirect-pqr.component.css']
})
export class RedirectPqrComponent implements OnInit {

    private _success = new Subject<{ message: string, type: string }>();
    alertData: {
        message: string,
        type: string
    } = {
            message: '',
            type: 'success'
        };
    idPqr: string = '';
    idUser: string = '';
    pass: string = '';
    pqr: ProyectQr = null;
    tempPqr: ProyectQr = null;
    infoPqr: {
        name: string,
        tel: string;
    } = {
        name: '',
        tel: ''
    };

    @ViewChild('contentModalCarpeta') contentModalCarpeta;
    modalCarpeta: NgbModalRef;
    modalCarpetaCloseResult: string;
    showCarpetaModal: {
        index: number;
        name: string;
        pdfs: PdfCarpetaProyectQr[];
    } = null;

    debounceTimeMessage: number = 5000;
    error: boolean = false;

    constructor(private _auth: AuthProvider, private navParams: ActivatedRoute, private _planes: PlanesProvider, public router: Router, private spinnerService: Ng4LoadingSpinnerService, public modalService: NgbModal) {
        let nserie = this.navParams.snapshot.paramMap.get('nserie');
        console.log(nserie);
        if (nserie.indexOf('finishSignUp') != -1 || nserie.indexOf('registro') != -1 || nserie.indexOf('login') != -1 || nserie.indexOf('dashboard') != -1) {
            this.router.navigate([nserie])
        } else {
            this.spinnerService.show();
            this._planes.findRedirectPqr(nserie).then(redirect => {
                if (redirect) {
                    // this.router.navigate([redirect]);
                    let redirectSplit = redirect.split('/');
                    this.idPqr = redirectSplit[redirectSplit.length - 1];
                    this.idUser = redirectSplit[1];
                    this._planes.findByUserPqr(this.idUser, this.idPqr).then(pqr => {
                        this.spinnerService.hide();
                        if (!pqr) {
                            this.debounceTimeMessage = 30000;
                            this.error = true;
                            this._success.next({ message: 'No existe el proyecto', type: 'danger' });
                            return true;
                        }

                        this.tempPqr = pqr;
                        this.infoPqr.name = pqr.personInfo;
                        this.infoPqr.tel = pqr.info;
                    });
                } else {
                    this.spinnerService.hide();
                    this.debounceTimeMessage = 30000;
                    this.error = true;
                    this._success.next({ message: 'No existe el proyecto', type: 'danger' });
                }
            });
        }
    }

    modalDismissReason(reason: any): string {
        if (reason === ModalDismissReasons.ESC) {
            return 'by pressing ESC';
        } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
            return 'by clicking on a backdrop';
        } else {
            return `with: ${reason}`;
        }
    }

    ngOnInit() {
        this._success.subscribe((alert) => {
            this.alertData.message = alert.message;
            this.alertData.type = alert.type;
        });
        this._success.pipe(
            debounceTime(this.debounceTimeMessage)
        ).subscribe(() => { this.alertData.message = null; this.debounceTimeMessage = 5000 });
    }

    openCarpeta(carpeta, i: number) {
        this.showCarpetaModal = carpeta;
        this.showCarpetaModal.index = i;
        this.showCarpetaModal.pdfs = carpeta.pdfs ? carpeta.pdfs : [];

        this.modalCarpeta = this.modalService.open(this.contentModalCarpeta, { windowClass: 'intra-modal-lg' });
        this.modalCarpeta.result.then((result) => {
            this.modalCarpetaCloseResult = `Closed with: ${result}`;
        }, (reason) => {
            this.modalCarpetaCloseResult = `Dismissed ${this.modalDismissReason(reason)}`;
        });
    }

    verificarPass() {
        console.log(this.pass, this.tempPqr.pass)
        if (this.tempPqr.pass !== this.pass) {
            this._success.next({ message: 'La contraseña no coincide', type: 'danger' });
            return true;
        }

        this.pqr = this.tempPqr;
    }

}



// WEBPACK FOOTER //
// ./src/app/pages/redirect-pqr/redirect-pqr.component.ts